import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useClientContext } from '@/context/client'
import { ROUTE_BUILDERS } from '@/config/routes'

export function SignContractPopup() {
  const { showAssinarPopup, setShowAssinarPopup, id_client, setMessage, setIsDialogOpen } = useClientContext()

  if (!showAssinarPopup) return null

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      const canShareNatively =
        typeof navigator.share === 'function' && /Android|iPhone|iPad/i.test(navigator.userAgent)

      if (canShareNatively) {
        try {
          await navigator.share({
            title: 'Assinar contrato',
            text: 'Clique para acessar e assinar a minuta:',
            url: text
          })
          setMessage({
            type: 'success',
            text: 'Link copiado e compartilhamento aberto com sucesso.'
          })
        } catch (shareError) {
          const error = shareError as Error | undefined
          if (error?.name === 'AbortError') {
            setMessage({
              type: 'success',
              text: 'Link copiado com sucesso.'
            })
          } else {
            throw shareError
          }
        }
      } else {
        setMessage({
          type: 'success',
          text: 'Link copiado com sucesso.'
        })
      }
      setIsDialogOpen(true)
    } catch (err) {
      console.error('Erro ao copiar ou compartilhar:', err)
      setMessage({
        type: 'error',
        text: 'Não foi possível copiar o link.'
      })
      setIsDialogOpen(true)
    }
  }

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50">
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="w-full max-w-md rounded-lg bg-background p-6 shadow-lg">
          <p className="mb-4 text-center">Compartilhe o link abaixo com a pessoa para ver a minuta e assinar o contrato:</p>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center sm:space-x-2 space-y-2 sm:space-y-0 mb-4">
            <Input
              type="text"
              readOnly
              value={`${window.location.origin}${ROUTE_BUILDERS.minute(id_client)}`}
              className="bg-input text-foreground"
            />
            <Button
              onClick={() => copyToClipboard(`${window.location.origin}${ROUTE_BUILDERS.minute(id_client)}`)}
              className="bg-primary text-primary-foreground w-full sm:w-auto"
            >
              Copiar Link
            </Button>
          </div>

          <Button onClick={() => setShowAssinarPopup(false)} className="mt-2 bg-primary text-primary-foreground w-full">
            Fechar
          </Button>
        </div>
      </div>
    </div>
  )
}
